import {
  getCoachingRecipients,
  updateCoachingRecipients,
  type TeammateCoachingAutomationSettings,
} from "@repo/app-types/entities/automation";
import type { FC } from "react";
import type { AutomationFieldsContext } from "./automationSettingsFields.js";
import { ConfigurationField } from "./configurationField.js";
import { PeoplePicker } from "./peoplePicker.js";

interface CoachingRecipientsFieldsProps {
  fieldsContext: AutomationFieldsContext;
  settings: TeammateCoachingAutomationSettings;
  onChange: (settings: TeammateCoachingAutomationSettings) => void;
}

export const CoachingRecipientsFields: FC<CoachingRecipientsFieldsProps> = (
  props,
) => {
  const { fieldsContext, settings, onChange } = props;

  return (
    <ConfigurationField
      label="Recipients"
      description="Teammates receive their own goals and progress updates. Managers receive their team’s summary."
    >
      <PeoplePicker
        ariaLabel="Coaching recipients"
        teammateOptions={fieldsContext.teammateOptions}
        managerTeammateIds={fieldsContext.managerTeammateIds}
        groupOptions={fieldsContext.groupOptions}
        value={getCoachingRecipients(settings)}
        onChange={(next) => onChange(updateCoachingRecipients(settings, next))}
        isLoading={fieldsContext.areRecipientOptionsLoading}
        isDisabled={fieldsContext.isReadOnly}
      />
    </ConfigurationField>
  );
};
